import React, { useEffect, useState } from "react";
import "./styles.scss";
import "react-notifications-component/dist/theme.css";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import Scrollbars from "react-custom-scrollbars-2";
import { Button, DropBox, FormHeader, InputBox } from "../../../components";
import { CheckValidity } from "../../../utils/formValidity";
import { useDispatch, useSelector } from "react-redux";
import {
  createNewTag,
  createTagWidget,
  createWidget,
  getAllTags,
  updateTag,
  updateWidget,
} from "../../Tags/service/tags.service";
import { Store } from "react-notifications-component";
import {
  clearSelectedTag,
  openCreateTagModal,
  openSelectTagsModal,
  setTagsList,
  updateTagsList,
} from "../../Tags/redux/actions";
import { clearedSelectItems } from "../../advertisement/redux/actions";
import TagsSelectBox from "../../templates/tagsSelectBox";
import { getLanguage } from "../../../utils";
import TagWidgetCard from "../../../components/tagWidgetCard";
import { getAllNews, getNewsByTag } from "../../news/service/news.service";
import { setNewsList } from "../../news/redux/actions";
import { getNewsByTags } from "../../newsViewPage/service/news.service";
import {
  clearSelectedWidget,
  updateWidgetList,
} from "../../Widget/redux/actions";

const lan = getLanguage();

const CreateNewWidgets = (props) => {
  const dispatch = useDispatch();
  const selectedTag = useSelector((state) => state.tagsReducer.selectedTag);
  // const { newsList } = useSelector(({ newsReducer }) => newsReducer);
  const selectedWidget = useSelector(
    (state) => state.widgetReducer.selectedWidget
  );

  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [selectTagList, setSelectTagList] = useState([]);
  const [selectedNews, setSelectNews] = useState([]);
  const [language, setLanguage] = useState(lan);
  const [selectList, setSelectList] = useState([]);
  const [finish, setFinish] = useState(true);
  const [newsList, setNewsList] = useState([]);
  const [filteredTags, setFilteredTags] = useState([]);

  const [formData, setFormData] = useState({
    findNews: {
      key: "findNews",
      label: "",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "Find news",
      },
      touched: false,
      validation: {
        required: false,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    widgetName: {
      key: "widgetName",
      label: "Widget name",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    // tagName: {
    //   key: "tagName",
    //   label: "Tags",
    //   size: "lg",
    //   placeholder: "Select Tags",
    //   mainLayerStyles: " flex-column align-content-center mb-3",
    //   iconName: "",
    //   isRequired: false,
    //   loading: false,
    //   elementConfig: {
    //     options: [],
    //   },
    //   touched: false,
    //   validation: {
    //     required: true,
    //   },
    //   isValid: false,
    //   invalidReason: "",
    //   value: "",
    // },
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = async (event, inputIdentity) => {
    const updateForm = {
      ...formData,
    };

    updateForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateForm[inputIdentity].value,
      updateForm[inputIdentity].validation
    );

    if (validityRes) {
      updateForm[inputIdentity].isValid = validityRes.isValid;
      updateForm[inputIdentity].invalidReason = validityRes.reason;
      updateForm[inputIdentity].value = event;
      updateForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateForm) {
        formIsValid = updateForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateForm);
    }
  };

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const clearAll = () => {
    const updateForm = {
      ...formData,
    };
    for (let key in updateForm) {
      updateForm[key].value = "";
      updateForm[key].isValid = false;
      updateForm[key].touched = false;
    }
    setSelectNews([]);
    setFilteredTags([]);
    setSelectTagList([]);
    setFormData(updateForm);

    props.refresh();
  };
  // const tagsSelect = (tags) => {
  //   setSelectTagList(tags);
  // };

  useEffect(() => {
    if (selectedWidget?.widget_id) {
      console.log("id", selectedWidget.widget_id);
      const updatedForm = {
        ...formData,
      };
      updateForm["widgetName"].value = selectedWidget?.widget_name || "";
      // updateForm["findNews"].value = selectedTag?.article_ids || [];
      setSelectNews(selectedWidget?.article_ids || []);

      setFormData(updatedForm);
    } else {
      for (let key in updateForm) {
        updateForm[key].value = "";
        updateForm[key].isValid = false;
        updateForm[key].touched = false;
      }
      setFormData(updateForm);
    }
  }, [selectedWidget]);

  // const fetchTags = async () => {
  //   const updateForm = { ...formData };
  //   updateForm.tagName.loading = true;
  //   updateForm["tagName"].elementConfig.options = [];
  //   const response = await getAllTags();
  //   if (response?.data) {
  //     let tagNameList = await syncTagName(response.data);
  //     updateForm["tagName"].elementConfig.options = tagNameList;
  //     updateForm.tagName.loading = false;
  //     dispatch(setTagsList(response.data));

  //     setFormData(updateForm);
  //   }
  // };
  // const syncTagName = async (res) => {
  //   let tagList = [];
  //   for (let tag of res) {
  //     const articleCount = tag.article_ids?.length || 0;
  //     tagList.push({
  //       id: tag.tag_id,
  //       key: tag.tag_name,
  //       value: tag.tag_id,
  //       displayValue: `${tag.tag_name} (${articleCount})`,
  //     });
  //   }
  //   return tagList;
  // };

  useEffect(() => {
    fetchNews();
    setSelectList([]);
  }, []);

  const fetchNews = async () => {
    const response = await getAllNews(language);
    console.log("News Response:", response);
    if (response?.data?.news) {
      setNewsList(response?.data?.news);
    }
  };

  // const fetchNewsByTags = async (tag_list) => {
  //     let param = window.location.pathname.split("/");
  //     let news_id = param?.[2];
  //     if (tag_list?.length > 0) {
  //       let result = await getNewsByTags(lan, { tag_ids: tag_list });
  //      console.log("tag news::", result?.data?.news);
  //       if (result?.data?.news?.length > 0) {
  //         let newsList = result?.data?.news;

  //        setNewsUpdateList(result?.data?.news);
  //       } else {
  //         setNewsUpdateList([]);
  //       }
  //     }};

  // useEffect(() => {
  //   if (newsList?.length === 0) {
  //     fetchNews();
  //   }
  // }, []);

  const onClickCreate = async () => {
    setIsLoading(true);

    const updateForm = { ...formData };
    try {
      let body = {
        widget_name: updateForm.widgetName.value,
        article_ids: selectedNews,
      };

      const response = await createWidget(body);
      console.log("widget Response:", response);
      setIsLoading(false);

      // ✅ Handle duplicate widget name
      // if (response?.status === 400) {
      //   Store.addNotification({
      //     title: "Duplicate Widget Name!",
      //     message:
      //       "A widget with this name already exists. Please choose another name.",
      //     type: "warning",
      //     insert: "top",
      //     container: "top-right",
      //     dismiss: { duration: 3000, onScreen: true },
      //   });
      //   return;
      // }

      if (response?.data) {
        console.log("widget Created Successfully");
        Store.addNotification({
          title: "Success!",
          message: "widget Created Successfully!",
          type: "success",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        clearAll();
      }
    } catch (error) {
      console.log("Error creating widget", error);
      Store.addNotification({
        title: "Error!",
        message: "widget Create Failed! Please try again.",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: { duration: 3000, onScreen: true },
      });
      setIsLoading(false);
      clearAll();
    }
  };

  const onClickUpdate = async () => {
    setIsLoading(true);
    if (selectedWidget?.widget_id) {
      const updateForm = { ...formData };
      const body = {
        widget_name: updateForm.widgetName.value,
        article_ids: selectedNews,
      };
      const response = await updateWidget(body, selectedWidget?.widget_id);
      console.log("Update Widget Response:", response);
      setIsLoading(false);
      try {
        if (response?.data?.status) {
          dispatch(updateWidgetList(response.data?.data));

          Store.addNotification({
            title: "Success!",
            message: "Widget Updated Successfully!",
            type: "success",
            insert: "top",
            container: "top-right",
            dismiss: { duration: 3000, onScreen: true },
          });
          setIsLoading(false);

          clearAll();
        }
      } catch (error) {
        console.log("Error updating Widget");
        Store.addNotification({
          title: "Error!",
          message: "Widget Update Failed!",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);

        clearAll();
      }
    }
  };

  const updateForm = { ...formData };

  return (
    <>
      <div className="hne-create-tag-wrapper">
        <FormHeader
          data={{
            formHeader: "Create New Tags Widgets",
            size: "md-md",
          }}
        />
        <div className="hne-tag-header-wrapper">
          {/* <DropBox
            data={updateForm.tagName}
            onChange={(e) => {
              const updateForm = { ...formData };
              updateForm["tagName"].value = e;
              setFormData(updateForm);
              setSelectTagList(e);

              fetchNews(e);
              console.log("Selected Tag:", e);
            }}
          /> */}

          <InputBox
            data={updateForm.widgetName}
            onChange={async (e) => {
              e.preventDefault();
              await handleChange(e.target.value, updateForm.widgetName.key);
            }}
          />

          <div
            className="hne-ctw-line mt-3 mb-3"
            style={{ height: "2px", background: "#D0CDCD", width: "100%" }}
          ></div>

          <InputBox
            data={updateForm.findNews}
            onChange={async (e) => {
              // const inputValue = e.target.value;
              const inputValue = e.target.value.trim().toLowerCase();
              await handleChange(inputValue, updateForm.findNews.key);

              if (inputValue === "") {
                // 🟢 Reset filter when input cleared
                setFilteredTags([]);
                return;
              }

              const filtered = newsList?.filter((item) =>
                item?.title?.[lan]
                  ?.toLowerCase()
                  .includes(inputValue.toLowerCase())
              );

              setFilteredTags(
                filtered?.length > 0 && inputValue !== "" ? filtered : []
              );
            }}
          />

          <Scrollbars
            onScroll={handleOnScroll}
            renderView={(props) => (
              <div {...props} style={{ ...props.style, overflowX: "hidden" }} />
            )}
            style={{ height: viewPointHeight - 450, marginTop: "15px" }}
          >
            <div
              className="d-flex flex-column flex-wrap mt-3"
              style={{ gap: "8px" }}
            >
              {/* {Array.isArray(newsList) &&
            newsList.length > 0 &&
            filteredTags.length === 0 &&
            filteredTags.length === 0 ? (
              newsList.map((item) => {
                const isActive = selectedNews?.includes(item?.news_id);
                return (
                  <div className="d-flex" key={item.id}>
                    <TagWidgetCard
                      isSelect={isActive ? "selected" : ""}
                      logo={item?.images?.[0]?.url}
                      titleSi={item?.title?.si}
                      closeDate={item?.created_at}
                      views={item?.views}
                      onClickSelect={() => {
                        if (!selectedNews.includes(item?.news_id)) {
                          setSelectNews([...selectedNews, item?.news_id]);
                        } else {
                          setSelectNews(
                            selectedNews.filter(
                              (news) => news !== item?.news_id
                            )
                          );
                        }
                      }}
                    />
                  </div>
                );
              })
            ) : updateForm.findNews.value !== "" &&
              Array.isArray(filteredTags) &&
              filteredTags.length > 0 ? (
              filteredTags.map((item) => {
                const isActive = selectedNews?.includes(item?.news_id); // Make this synchronous

                return (
                  <div className="d-flex" key={item.id}>
                    <TagWidgetCard
                      isSelect={""}
                      logo={item?.images?.[0]?.url}
                      titleSi={item?.title?.si}
                      closeDate={item?.created_at}
                      views={item?.views}
                      onClickSelect={() => {
                        if (!selectedNews.includes(item?.news_id)) {
                          setSelectNews([...selectedNews, item?.news_id]);
                        } else {
                          setSelectNews(
                            selectedNews.filter(
                              (news) => news !== item?.news_id
                            )
                          );
                        }
                      }}
                    />
                  </div>
                );
              })
            ) : (
              <div className="error-message">No News Found</div>
            )} */}

              {/* {Array.isArray(newsList) && newsList.length > 0 ? (
                newsList.map((item) => {
                  const isActive = selectedNews?.includes(item?.news_id); */}

              {(filteredTags.length > 0 ? filteredTags : newsList).length >
              0 ? (
                (filteredTags.length > 0 ? filteredTags : newsList)
                  // Optional: sort so selected appear first
                  .sort((a, b) => {
                    const aSelected = selectedNews.includes(a.news_id);
                    const bSelected = selectedNews.includes(b.news_id);
                    return aSelected === bSelected ? 0 : aSelected ? -1 : 1;
                  })
                  .map((item) => {
                    const isActive = selectedNews?.includes(item?.news_id);
                    return (
                      <div className="d-flex" key={item.news_id}>
                        <TagWidgetCard
                          isSelect={isActive ? "selected" : ""}
                          logo={item?.images?.[0]?.url}
                          titleSi={item?.title?.si}
                          closeDate={item?.created_at}
                          views={item?.views}
                          onClickSelect={() => {
                            if (!selectedNews.includes(item?.news_id)) {
                              setSelectNews([...selectedNews, item?.news_id]);
                            } else {
                              setSelectNews(
                                selectedNews.filter(
                                  (news) => news !== item?.news_id
                                )
                              );
                            }
                          }}
                        />
                      </div>
                    );
                  })
              ) : (
                <div className="error-message">No News Found</div>
              )}
            </div>
          </Scrollbars>
        </div>
        <div
          className="d-flex flex-row justify-content-between"
          style={{ marginBottom: "15px" }}
        >
          {selectedWidget?.widget_id && (
            <Button
              data={{
                btnName: "Clear",
                buttonType: "secondary mr-2",
                buttonSize: "lg",
                isLoading: isLoading,
              }}
              onClick={async (e) => {
                e.preventDefault();
                dispatch(clearSelectedWidget());
                clearAll();
                setFinish(true);
              }}
            />
          )}
          <Button
            data={{
              btnName: selectedWidget?.widget_id ? "UPDATE" : "DONE",
              buttonType:
                updateForm.widgetName.value === ""
                  ? "primary disabled"
                  : "primary",
              buttonSize: "lg",
              isLoading: isLoading,
              disable: updateForm.widgetName.value === "" ? true : false,
            }}
            onClick={async (e) => {
              e.preventDefault();
              if (selectedWidget?.widget_id) {
                await onClickUpdate(e);
              } else {
                await onClickCreate(e);
              }
            }}
          />
        </div>
      </div>
    </>
  );
};
export default withRouter(CreateNewWidgets);
